import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const FullContainer = styled.div`
  display: flex;
  flex-grow: 2;
  justify-content: center;
  background: ${({ theme }) => theme.group.whiteGrey};

  width: 100%;
  height: calc(100% - 80px);

  @media ${({ theme }) => theme.device.desktop} {
    height: calc(100vh - 301px);
    background: none;
  }
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  width: 100%;
`;

export const BgImage = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  width: 100%;
  height: 100%;
  flex-direction: column;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
    margin-right: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    background-image: url('/corporate/images/illustration-card.png');
    background-position: center bottom;
    background-repeat: no-repeat;
  }

  &.user {
    background-position: center 90%;
    background-size: 90%;

    @media ${({ theme }) => theme.device.desktop} {
      background-position: center;
      background-size: auto;
    }
  }
`;

export const Illustration = styled.img`
  height: 25vh;
  width: auto;
  margin: auto;
  margin-bottom: 0;
`;

export const Content = styled.div`
  text-align: left;
  width: calc(100% - 34px);
  margin: 20px 17px;
  color: ${ColorPalette.HEX.DimGray};
  font-size: 16px;
  line-height: 24px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  padding: 18px 16px;

  @media ${({ theme }) => theme.device.desktop} {
    padding: 18px 0;
  }
`;

export const Title = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.title};
`;
